import DraggablePrizeCard from "./draggablePrizeCard.container";

export default DraggablePrizeCard;
